"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionedMenuContent = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var positioningCalculations_1 = require("./positioningCalculations");
var PositionedMenuContent = /** @class */ (function (_super) {
    tslib_1.__extends(PositionedMenuContent, _super);
    function PositionedMenuContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            left: 0,
            top: 0,
        };
        _this.menuElRef = react_1.createRef();
        _this.positionMenu = function () {
            if (!_this.props.togglerEl || !_this.menuElRef.current) {
                return;
            }
            var _a = positioningCalculations_1.calculateMenuPosition({
                toggler: positioningCalculations_1.getElementDimensionsAndCoords(_this.props.togglerEl),
                menu: positioningCalculations_1.getElementDimensions(_this.menuElRef.current),
                viewport: positioningCalculations_1.getViewportDimensionsAndCoords(),
                alignment: _this.props.alignment,
                spacing: _this.props.spacing,
                offset: _this.props.offset,
                topLevelMenu: _this.props.topLevelMenu,
            }), left = _a.left, top = _a.top;
            _this.setState({ left: left, top: top });
        };
        return _this;
    }
    PositionedMenuContent.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.alignment !== this.props.alignment ||
            prevProps.spacing !== this.props.spacing ||
            prevProps.offset !== this.props.offset ||
            prevProps.topLevelMenu !== this.props.topLevelMenu ||
            prevProps.togglerEl !== this.props.togglerEl ||
            prevProps.children !== this.props.children) {
            this.positionMenu();
        }
    };
    PositionedMenuContent.prototype.componentDidMount = function () {
        this.positionMenu();
        this.addEventListeners();
    };
    PositionedMenuContent.prototype.componentWillUnmount = function () {
        this.removeEventListeners();
    };
    PositionedMenuContent.prototype.render = function () {
        return (react_1.default.createElement("div", { style: {
                position: "absolute",
                left: this.state.left,
                top: this.state.top,
            }, ref: this.menuElRef }, this.props.children));
    };
    PositionedMenuContent.prototype.addEventListeners = function () {
        window.addEventListener("resize", this.positionMenu);
        window.addEventListener("scroll", this.positionMenu, true);
    };
    PositionedMenuContent.prototype.removeEventListeners = function () {
        window.removeEventListener("resize", this.positionMenu);
        window.removeEventListener("scroll", this.positionMenu, true);
    };
    return PositionedMenuContent;
}(react_1.default.Component));
exports.PositionedMenuContent = PositionedMenuContent;
//# sourceMappingURL=PositionedMenuContent.js.map